<template>
    <div class="contain">
        <div class="posting-uploader">
            <div
                    class="posting-uploader-item"
                    v-for="(item, index) in postData"
                    :key="index"
            >
                <van-tag plain round closeable @close="remove(index)">{{item.name}}</van-tag>
            </div>
            <van-uploader
                    :accept="accept"
                    :after-read="uploadFile"
                    :before-read="beforeRead"
                    upload-icon="column"
                    v-show=" postData.length < limit"
                    result-type="text"
                    upload-text="上传文件"
            >
            </van-uploader>
        </div>
        <van-popup v-model="showLoading">
            <van-loading type="spinner" color="#1989fa" />
        </van-popup>
    </div>
</template>

<script>
    import OSS from 'ali-oss';
    import {Uploader, Toast, Loading,Tag } from 'vant';
    import Vue from 'vue';

    Vue.use(Uploader).use(Toast).use(Loading).use(Tag);

    export default {
        props: {
            fileList: Array,
            accept: {
                type: String,
                default: '.jpg,.png,.gif,.jpeg,.doc,.pdf,.ppt,.docx,.xls,.xlsx,.pptx,.rar,.zip',
            },
            limit: {
                type: Number,
                default: 0,
            },
            name: {
                type: String,
                default: ''
            },
            beforeRead:{
                type:Function,
                default:() =>{
                }
            }
        },
        data() {
            return {
                postData: [],
                uid: 0,
                showLoading: false,
                ossAccessTokenURL: 'https://api.dierqudao.com/core/attachment/aliOssSts',
                ossFileURL: 'https://cheeseman.oss-cn-hangzhou.aliyuncs.com',
            }
        },
        mounted() {
            this.postData = this.fileList
        },
        watch: {
            fileList(value) {
                this.postData = value
            }
        },
        methods: {

            remove(index) {
                // 删除指定下标的图片对象
                let that = this;
                if (isNaN(index) || index >= that.postData.length) {
                    return false
                }

                this.postData.splice(index, 1)
                this.$emit('fileListChange', {'pic': that.postData, 'name': that.name})
            }, 

            uploadFile(evt) {
                console.log('------uploadFile------')
                let that = this;
                that.showLoading = true;
                OSS.urllib.request(that.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
                    let result;
                    if (err) {
                        Toast.fail('上传异常:' + err);
                        console && console.error(err);
                        return;
                    }

                    try {
                        result = JSON.parse(response);
                    } catch (e) {
                        return alert('parse sts response info error: ' + e.message);
                    }

                    var client = new OSS({
                        accessKeyId: result.data.AccessKeyId,
                        accessKeySecret: result.data.AccessKeySecret,
                        stsToken: result.data.SecurityToken,
                        endpoint: result.data.endpoint,
                        bucket: result.data.bucket,
                        secure: true
                    });

                    var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];

                    var myDate = new Date().getTime();
                    let time = myDate + '' + (Math.floor(Math.random() * 1000 + 1));
                    let date = that.dateFormat(myDate);

                    var file_save_name = 'h5/' + date + '/' + time + '/' + evt.file.name;
                    client.multipartUpload(file_save_name, evt.file).then(function (result) {
                        console.log(that.ossFileURL);
                        var file = {
                            uid: 'vc-upload-'+time,
                            url: that.ossFileURL + '/' + file_save_name,
                            name: evt.file.name,
                            save_name: file_save_name
                        }
                        that.postData.push(file);

                        that.showLoading = false;
                        // Toast.success(evt.file.name + '上传成功');
                        that.$emit('fileListChange', {'pic': that.postData, 'name': that.name})
                    }).catch(function (err) {
                        // Toast.fail(evt.file.name + '上传失败');
                    })

                })
            },

        }
    }
</script>

<style scoped>
    .contain >>> .van-popup{
        background: none;
    }

    .posting-uploader {
        display: flex;
        flex-wrap: wrap;
    }

    .posting-uploader-item {
        position: relative;
        margin: 0 8px 8px 0;
    }

    .imgPreview {
        /*display: block;*/
        width: 80px;
        height: 80px;
    }

    .delte {
        /*margin-left: -15px;
        width: 10px;
        height: 10px;
        margin-right: 20px;*/
        position: absolute;
        right: 0;
        top: 0;
        padding: 1px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.45);
    }

    .upload-img-5 {
        margin: 5px 0 90px 0;
    }

    .upload-img-1 {
        margin: 5px 0 15px 0;
    }
</style>



// WEBPACK FOOTER //
// FileUploader.vue?9009fb18